"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayRecipientInformation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
let MangopayRecipientInformation = class MangopayRecipientInformation {
    _id = (0, uuid_1.v4)();
    recipientId;
    currency = legacy_enums_1.Currency.Euro;
    status;
    activatedAt;
    pendingUserAction;
    scaStartedAt;
};
exports.MangopayRecipientInformation = MangopayRecipientInformation;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayRecipientInformation.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayRecipientInformation.prototype, "recipientId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], MangopayRecipientInformation.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.MangopayRecipientStatus),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayRecipientInformation.prototype, "status", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], MangopayRecipientInformation.prototype, "activatedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], MangopayRecipientInformation.prototype, "pendingUserAction", void 0);
__decorate([
    transformToDate_1.TransformToDate,
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], MangopayRecipientInformation.prototype, "scaStartedAt", void 0);
exports.MangopayRecipientInformation = MangopayRecipientInformation = __decorate([
    (0, class_transformer_1.Exclude)()
], MangopayRecipientInformation);
//# sourceMappingURL=MangopayRecipientInformation.js.map